import { quizzVersions } from "../../data/quizzVersions";
import { QuizzVersionButton } from "./QuizzVersionButton";
import React from "react";
import "../../styles/QuizzChoice.css";
import { DisplayWelcoming } from "./DisplayWelcoming";

export const QuizzChoice = ({ handleClickOnQuizzVersion }) => {
  return (
    <div className="container_homepage">
      <DisplayWelcoming />
      <div className="container_homepage_bouttons">
        {/* {quizzVersions.map((quizzVersion) => (
          <QuizzVersionButton
            key={quizzVersion.id}
            quizzVersion={quizzVersion}
            handleClickOnQuizzVersion={handleClickOnQuizzVersion}
          />
        ))} */}
        {/* Ci-dessus, la version permettant d'afficher 2 possibilités : Bouton Quiz Simple, Bouton Quiz Détaillé */}
        <QuizzVersionButton
          quizzVersion={quizzVersions[0]}
          handleClickOnQuizzVersion={handleClickOnQuizzVersion}
        />
      </div>
    </div>
  );
};
